import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Badge from "../../components/common/Badge/Badge";
import TabsNavigation from "../../components/common/TabsNavigation/TabsNavigation";
import Table from "../../components/common/Table/Table";
import "./FichaGestor.scss";
import DetalleLayout from "../../Layouts/DetalleLayout/DetalleLayout";
import { useZone } from "../../context/ZoneContext";
import { getApiInstance } from "../../utils/api";
import { CiClock1 } from "react-icons/ci";
import { CgDanger } from "react-icons/cg";
import { CiCircleCheck } from "react-icons/ci";
import { formatDate } from "../../utils/utils";


// API Functions (comentadas hasta que esté disponible la API)
/*
const fetchGestor = async (id) => {
    try {
        const response = await fetch(`/api/gestores/${id}`);
        if (!response.ok) {
            throw new Error('Error al obtener el gestor');
        }
        return await response.json();
    } catch (error) {
        console.error('Error fetching gestor:', error);
        throw error;
    }
};

const fetchDocumentosGestor = async (gestorId) => {
    try {
        const response = await fetch(`/api/gestores/${gestorId}/documentos`);
        if (!response.ok) {
            throw new Error('Error al obtener los documentos');
        }
        return await response.json();
    } catch (error) {
        console.error('Error fetching documentos:', error);
        throw error;
    }
};

const fetchTarifasGestor = async (gestorId) => {
    try {
        const response = await fetch(`/api/gestores/${gestorId}/tarifas`);
        if (!response.ok) {
            throw new Error('Error al obtener las tarifas');
        }
        return await response.json();
    } catch (error) {
        console.error('Error fetching tarifas:', error);
        throw error;
    }
};
*/

// Datos mock de documentos
const mockDocumentos = [
    {
        id: 1,
        tipoDocumento: "Autorización tratamiento residuos",
        nombreArchivo: "Transportista Gestan Conteco.pdf",
        fechaValidez: "05/06/2024",
        fechaVencimiento: "05/06/2024",
        estado: "VALIDADO",
    },
    {
        id: 2,
        tipoDocumento: "Autorización tratamiento residuos",
        nombreArchivo: "Gestán contenedores.png",
        fechaValidez: "01/08/2025",
        fechaVencimiento: "31/12/2040",
        estado: "VALIDADO",
    },
];

// Datos mock de tarifas
const mockTarifas = [
    {
        id: 1,
        tipoResidue: "Residuos peligrosos",
        precio: "0.85 €/kg",
        vigencia: "01/01/2024 - 31/12/2024",
        estado: "ACTIVA",
    },
    {
        id: 2,
        tipoResidue: "Residuos industriales",
        precio: "0.45 €/kg",
        vigencia: "01/01/2024 - 31/12/2024",
        estado: "ACTIVA",
    },
    {
        id: 3,
        tipoResidue: "Aceites usados",
        precio: "1.20 €/l",
        vigencia: "01/06/2024 - 31/05/2025",
        estado: "PENDIENTE",
    },
];

// Elementos del formulario para documentos
const formElementsDocumentos = [
    {
        elements: [
            {
                name: "tipoDocumento",
                type: "select",
                label: "Tipo de documento",
                placeholder: "Seleccione el tipo de documento",
                required: true,
                disabled: false,
                labelVisible: true,
                visible: true,
                options: [
                    {
                        value: "autorizacion_tratamiento",
                        label: "Autorización tratamiento residuos",
                    },
                    {
                        value: "licencia_actividad",
                        label: "Licencia de actividad",
                    },
                    {
                        value: "seguro_responsabilidad",
                        label: "Seguro de responsabilidad civil",
                    },
                    { value: "certificado_iso", label: "Certificado ISO" },
                    { value: "otros", label: "Otros" },
                ],
            },
            {
                name: "nombreArchivo",
                type: "text",
                label: "Nombre del archivo",
                placeholder: "Ingrese el nombre del archivo",
                required: true,
                disabled: false,
                labelVisible: true,
                visible: true,
            },
            {
                name: "fechaValidez",
                type: "text",
                label: "Fecha de validez (DD/MM/AAAA)",
                placeholder: "01/01/2024",
                required: true,
                disabled: false,
                labelVisible: true,
                visible: true,
            },
            {
                name: "fechaVencimiento",
                type: "text",
                label: "Fecha de vencimiento (DD/MM/AAAA)",
                placeholder: "31/12/2024",
                required: true,
                disabled: false,
                labelVisible: true,
                visible: true,
            },
            {
                name: "observaciones",
                type: "textarea",
                label: "Observaciones",
                placeholder: "Ingrese observaciones adicionales",
                required: false,
                disabled: false,
                labelVisible: true,
                visible: true,
                rows: 3,
            },
        ],
    },
];

export default function FichaGestor() {
    const { id } = useParams();
    const [gestor, setGestor] = useState(null);
    const [documentos, setDocumentos] = useState([]);
    const [tarifas, setTarifas] = useState([]);
    const [activeTabGeneral, setActiveTabGeneral] = useState("informacion");
    const [activeTabDatos, setActiveTabDatos] = useState("documentacion");
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const { selectedZone } = useZone();

    const fetchGestor = async (id) => {
        try {
            const api = getApiInstance();
            console.log(`Fetching gestor with ID: ${id}`)
            const response = await api.get(`/api/Proveedores/GetProveedorById/${id}?codZona=${selectedZone.value}&codZonaLegal=1`);
            return await response.data;
        } catch (error) {
            console.error('Error fetching gestor:', error);
            throw error;
        }
    };

    const fetchDocumentos = async (id) => {
        try {
            const api = getApiInstance();
            const response = await api.get(`/api/GestorDocumentos/GetDocumentosFromGestor/${id}`);
            return await response.data;
        } catch (error) {
            console.error('Error fetching gestor:', error);
            throw error;
        }
    };

    const fetchTarifas = async (id) => {
        try {
            const api = getApiInstance();
            const response = await api.get(`/api/Tarifa/GetTarifasByProveedor/${id}`);
            return await response.data;
        } catch (error) {
            console.error('Error fetching gestor:', error);
            throw error;
        }
    };

useEffect(() => {
  const loadGestorData = async () => {
    try {
      setLoading(true);
      setError(null);

      const results = await Promise.allSettled([
        fetchGestor(id),
        fetchDocumentos(id),
        fetchTarifas(id)
      ]);

      const [gestorRes, docRes, tarifaRes] = results;

      const gestorData = gestorRes.status === 'fulfilled' ? gestorRes.value : null;
      const documentosData = docRes.status === 'fulfilled' ? docRes.value : [];
      const tarifasData = tarifaRes.status === 'fulfilled' ? tarifaRes.value : [];

      setGestor(gestorData);
      setDocumentos(documentosData);
      setTarifas(tarifasData);

      // opcional: si gestorRes rechazó por algo distinto a 404, mostrarlo
      if (gestorRes.status === 'rejected') {
        setError(gestorRes.reason?.message || 'Error al cargar gestor');
      }
    } catch (err) {
      console.error("Error cargando datos del gestor:", err);
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  if (id) loadGestorData();
}, [id]);

    const getEstadoBadge = (estado) => {
        const estadoConfig = {
            VALIDADO: { type: "success", label: "Validado", Icon: CiCircleCheck},
            PENDIENTE: { type: "info", label: "Pendiente", Icon: CiClock1},
            INCIDENCIA: { type: "warning", label: "Incidencia", Icon: CgDanger},
            VENCIDO: { type: "error", label: "Vencido", Icon: CgDanger},
            ACTIVA: { type: "success", label: "Activa", Icon: CiCircleCheck},
        };
        return estadoConfig[estado] || estadoConfig["PENDIENTE"];
    };

    const tabsGeneral = [
        { id: "informacion", label: "Información General" },
        { id: "localizacion", label: "Localización" },
    ];

    const tabsDatos = [
        { id: "documentacion", label: "Documentación" },
        { id: "tarifas", label: "Tarifas" },
    ];

    const renderInformacionGeneral = () => (
        <div className="ficha-gestor__info">
            <div className="ficha-gestor__field">
                <label>Nombre:</label>
                <span>{gestor.nombre}</span>
            </div>
            <div className="ficha-gestor__field">
                <label>CIF:</label>
                <span>{gestor.cif}</span>
            </div>
            <div className="ficha-gestor__field">
                <label>Contacto:</label>
                <span>{gestor.contacto}</span>
            </div>
            <div className="ficha-gestor__field">
                <label>Teléfono:</label>
                <span>{gestor.telefono}</span>
            </div>
            <div className="ficha-gestor__field">
                <label>Email:</label>
                <span>{gestor.email}</span>
            </div>
            <div className="ficha-gestor__field">
                <label>Tipo:</label>
                <span>{gestor.tipo}</span>
            </div>
            <div className="ficha-gestor__field">
                <label>Estado:</label>
                <span className="ficha-gestor__field-badge">
                    <Badge variant={getEstadoBadge(gestor.codEstado).type} Icon={getEstadoBadge(gestor.codEstado).Icon}>
                        {getEstadoBadge(gestor.codEstado).label}
                    </Badge>
                </span>
            </div>
        </div>
    );

    const renderLocalizacion = () => (
        <div className="ficha-gestor__info">
            <div className="ficha-gestor__field">
                <label>Dirección:</label>
                <span>{gestor.direccion}</span>
            </div>
            <div className="ficha-gestor__field">
                <label>Localidad:</label>
                <span>{gestor.localidad}</span>
            </div>
            <div className="ficha-gestor__field">
                <label>Código postal:</label>
                <span>{gestor.codigoPostal}</span>
            </div>
            <div className="ficha-gestor__field">
                <label>Provincia:</label>
                <span>{gestor.provincia}</span>
            </div>
            <div className="ficha-gestor__field">
                <label>Comunidad:</label>
                <span>{gestor.comunidad}</span>
            </div>
            <div className="ficha-gestor__field">
                <label>País:</label>
                <span>{gestor.pais}</span>
            </div>
        </div>
    );

    const renderGeneralContent = () => {
        switch (activeTabGeneral) {
            case "informacion":
                return renderInformacionGeneral();
            case "localizacion":
                return renderLocalizacion();
            default:
                return renderInformacionGeneral();
        }
    };

    const renderDatosContent = () => {
        switch (activeTabDatos) {
            case "documentacion":
                return (
                    <div className="ficha-gestor__documentacion">
                        <Table
                            columns={[
                                {
                                    key: "tipoDocumento",
                                    label: "Tipo de documento",
                                    visible: true,
                                    sortable: true,
                                },
                                {
                                    key: "documento",
                                    label: "Documento",
                                    visible: true,
                                    sortable: true,
                                    type: "document",
                                    documentProp: "ficheroBase64"
                                },
                                {
                                    key: "validez",
                                    label: "Validez",
                                    visible: true,
                                    sortable: true,
                                    render: (row) =>
                                        `${formatDate(row.fechaIni)} - ${formatDate(row.fechaFin)}`,
                                },
                                {
                                    key: "codEstado",
                                    label: "Validación",
                                    visible: true,
                                    sortable: true,
                                },
                            ]}
                            dataTable={documentos}
                            noResultsMessage="No hay documentos disponibles"
                            rowsPerPage={10}
                            showCheckboxes={false}
                            actions={["Eliminar"]}
                            elementName="Documento"
                            stateProp="codEstado"
                            states={[
                                { type: "primary", label: "", Icon: null },
                                { type: "info", label: "Pendiente de validar", Icon: CiClock1 },
                                { type: "warning", label: "Validación con incidencias", Icon: CgDanger },
                                { type: "success", label: "Validado", Icon: CiCircleCheck},
                            ]}
                            formElements={formElementsDocumentos}
                            addApiUrl="/api/GestorDocumentos/SetDocumento"
                            deleteApiUrl="/api/GestorDocumentos/DeleteDocumento"
                            loading={loading}
                        />
                    </div>
                );
            case "tarifas":
                return (
                    <div className="ficha-gestor__tarifas">
                        <Table
                            columns={[
                                {
                                    key: "tipoResidue",
                                    label: "Tipo de residuo",
                                    visible: true,
                                    sortable: true,
                                },
                                {
                                    key: "precio",
                                    label: "Precio",
                                    visible: true,
                                    sortable: true,
                                },
                                {
                                    key: "vigencia",
                                    label: "Vigencia",
                                    visible: true,
                                    sortable: true,
                                },
                                {
                                    key: "codEstado",
                                    label: "Estado",
                                    visible: true,
                                    sortable: true
                                },
                            ]}
                            dataTable={tarifas}
                            noResultsMessage="No hay tarifas disponibles"
                            rowsPerPage={10}
                            showCheckboxes={false}
                            actions={["Editar", "Eliminar"]}
                            elementName="Tarifa"
                            stateProp="codEstado"
                            states={[
                                { type: "primary", label: "", Icon: null },
                                { type: "info", label: "Pendiente de validar", Icon: CiClock1},
                                {type: "warning", label: "Validación con incidencias", Icon: CgDanger},
                                {type: "success", label: "Validado", Icon: CiCircleCheck}
                            ]}
                            formElements={[    {
        elements: [
            {
                name: "codProveedor",
                type: "text",
                required: true,
                disabled: false,
                visible: false,
                defultValue: `${id}`,
            },
{
                name: "proveedores",
                type: "text",
                required: true,
                disabled: false,
                visible: false,
                defultValue: `${gestor.nombre}`,
            },
            {
                name: "fechaInicio",
                type: "text",
                label: "Fecha de inicio (DD/MM/AAAA)",
                placeholder: "01/01/2024",
                required: true,
                disabled: false,
                labelVisible: true,
                visible: true,
            },
            {
                name: "fechaFin",
                type: "text",
                label: "Fecha de fin (DD/MM/AAAA)",
                placeholder: "31/12/2024",
                required: true,
                disabled: false,
                labelVisible: true,
                visible: true,
            },
            {
                name: "descr",
                type: "textarea",
                label: "Descripción",
                placeholder: "Ingrese una descripción",
                required: false,
                disabled: false,
                labelVisible: true,
                visible: true,
                rows: 3,
            },
        ],
    }]}
                            addApiUrl="/api/Tarifa/SetTarifa"
                            deleteApiUrl="/api/Tarifa/DeleteTarifa"
                            loading={loading}
                        />
                    </div>
                );
            default:
                return null;
        }
    };

    return (
        <DetalleLayout
            title={gestor ? `Gestor ${gestor.nombre}` : "Cargando..."}
            backLink="/gestores"
            backText="Volver a Gestores"
            loading={loading}
            error={error}
            notFound={!gestor && !loading && !error}
            className="ficha-gestor"
        >
            {!loading && !error && gestor && (
                <div className="ficha-gestor__content">
                    <div className="ficha-gestor__section">
                        <div className="ficha-gestor__section-header">
                            <h2>Información General</h2>
                        </div>

                        <TabsNavigation
                            tabs={tabsGeneral}
                            activeTab={activeTabGeneral}
                            onTabChange={setActiveTabGeneral}
                        />

                        <div className="ficha-gestor__section-content">
                            {renderGeneralContent()}
                        </div>
                    </div>

                    <div className="ficha-gestor__section">
                        <div className="ficha-gestor__section-header">
                            <h2>Datos del gestor</h2>
                        </div>

                        <TabsNavigation
                            tabs={tabsDatos}
                            activeTab={activeTabDatos}
                            onTabChange={setActiveTabDatos}
                        />

                        <div className="ficha-gestor__section-content">
                            {renderDatosContent()}
                        </div>
                    </div>
                </div>
            )}
        </DetalleLayout>
    );
}
